import type { FlowCategoriesT } from 'components/powerFlowShared/helpers/flowVariableHelpers';

import { getTokenString } from '../getTokenString/getTokenString';

export function replaceTokensWithTags(
  content: string,
  variables: FlowCategoriesT,
): string {
  const flattenedVariableNames = variables.flatMap(
    (category) => category.items,
  );

  return content.replace(
    /{{([^:]*:)?([^}]+)}}/g,
    (group, scope = '', variableName = '') => {
      const completeMatch = scope + variableName;
      const nameMatch = flattenedVariableNames.find(
        (vName) => vName.name === completeMatch,
      );

      if (nameMatch) {
        return getTokenString(completeMatch, nameMatch.content);
      }

      return group;
    },
  );
}
